import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

const CookiePolicyPage = () => {
  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${apiBase}/backend/api.php?action=getCookiePolicy`);
        const data = await res.json();
        setContent(data?.content || '');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="container mx-auto max-w-7xl px-4 py-12">
      <h1 className="text-3xl font-bold mb-6">Çerez Politikası</h1>
      {loading ? (
        <div>Yükleniyor...</div>
      ) : (
        <div
          className="prose max-w-none"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(content || '<p>Bu sayfa yakında güncellenecektir.</p>')
          }}
        />
      )}
    </div>
  );
};

export default CookiePolicyPage;






















